import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

const initializeGoogleAnalytics = (): void => {
  // Initialize UA
  ReactGA.initialize('UA-XXXXXXXX-X');
  // Initialize GA4 - Add your measurement ID
  ReactGA4.initialize('G-XXXXXXXXXX');
};

const trackGoogleAnalyticsEvent = (
  category: string,
  action: string,
  label: string,
): void => {
  // Send UA Event
  ReactGA.event({
    category,
    action,
    label,
  });
  // Send GA4 Event
  ReactGA4.event({
    category,
    action,
    label,
  });
};

export { initializeGoogleAnalytics, trackGoogleAnalyticsEvent };
